var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinBf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49999 2.89827C6.49999 4.37741 5.3717 5.57445 3.60725 5.57445C1.91154 5.57445 0.783253 4.37741 0.818171 2.89827C0.783253 1.34724 1.91151 0.185059 3.64105 0.185059C5.37167 0.185059 6.46616 1.34724 6.49999 2.89827ZM0.960031 24.9177V7.68859H6.3243V24.9166H0.960031V24.9177Z",
    fill: "#FAB80E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6243 13.187C10.6243 11.038 10.5533 9.20595 10.4824 7.69086H15.1418L15.3895 10.0512H15.4953C16.2013 8.95871 17.9658 7.3042 20.8247 7.3042C24.3536 7.3042 27.0009 9.62965 27.0009 14.701V24.9199H21.6365V15.3719C21.6365 13.1511 20.8607 11.6371 18.9195 11.6371C17.4366 11.6371 16.5549 12.6587 16.2024 13.6445C16.0606 13.9974 15.9908 14.4897 15.9908 14.9842V24.9199H10.6264V13.187H10.6243Z",
    fill: "#FAB80E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBf);
export default __webpack_public_path__ + "static/media/linkedin-bf.9fabb8b97ceb5c763c81c89be6670712.svg";
export { ForwardRef as ReactComponent };